import { useState } from "react";

export function useSymbol() {
  const [symbol, setSymbol] = useState(Symbol());
  return [symbol, () => setSymbol(Symbol())];
}

export default useSymbol;
